// extracted by mini-css-extract-plugin
module.exports = {"subCategory":"SubCategories_subCategory__3fRIR"};